/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { Iceutility } from '../../services/iceutility';
import { incomerevenuejournal } from '../accounting/incomerevenuejournal';
import { basecode } from '../ehr/subs/basecode';
import { medicationactivity } from '../ehr/subs/medicationactivity';
import { reviewer } from '../ehr/subs/reviewer';
import { accountingsummary } from '../stats/accountingsummary';
import { antenatalattendancestat } from '../stats/antenatalattendancestat';
import { labordeliverystat } from '../stats/labordeliverystat';
import { patientstat } from '../stats/patientstat';
import { pharmacystat } from '../stats/pharmacystat';
import { providerstat } from '../stats/providerstat';
import { viralstat } from '../stats/viralstat';
import { report, reportDataField } from './report';

export class reportdata extends report {
  public report_key: string = "";
  public collection_status: number = 0.0;

  ANTENATAL_ATTENDANCE_STAT: antenatalattendancestat[] = [];
  LABOR_DELIVERY_STAT: labordeliverystat[] = [];
  PATIENTSTATS: patientstat[] = [];
  PROVIDERSTATS: providerstat[] = [];
  PHARMACYSTATS: pharmacystat[] = [];
  VIRAL_STAT: viralstat[] = [];
  ACCOUNTING_SUMMARY: accountingsummary[] = [];
  SERVICESTATS: accountingsummary[] = [];
  REVIEWS: reviewer[] = [];
  REVENUES: incomerevenuejournal[] = [];
  MEDACTIVITIES: medicationactivity[] = [];
  GENERALCODES: basecode[] = [];

  public gettablename(): string {
    return "REPORT_DATA";
  }

  public hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "ANTENATAL_ATTENDANCE_STAT") return true;
    else if (ColumnName == "LABOR_DELIVERY_STAT") return true;
    else if (ColumnName == "PATIENTSTATS") return true;
    else if (ColumnName == "PROVIDERSTATS") return true;
    else if (ColumnName == "PHARMACYSTATS") return true;
    else if (ColumnName == "VIRAL_STAT") return true;
    else if (ColumnName == "ACCOUNTING_SUMMARY") return true;
    else if (ColumnName == "SERVICESTATS") return true;
    else if (ColumnName == "REVIEWS") return true;
    else if (ColumnName == "REVENUES") return true;
    else if (ColumnName == "MEDACTIVITIES") return true;
    else if (ColumnName == "GENERALCODES") return true;

    return false;
  }

  public getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "ANTENATAL_ATTENDANCE_STAT") return "ANTENATAL_ATTENDANCE_STAT";
    else if (ColumnName == "LABOR_DELIVERY_STAT") return "LABOR_DELIVERY_STAT";
    else if (ColumnName == "PATIENTSTATS") return "PATIENT_STAT";
    else if (ColumnName == "PROVIDERSTATS") return "PROVIDER_STAT";
    else if (ColumnName == "PHARMACYSTATS") return "PHARMACY_STAT";
    else if (ColumnName == "VIRAL_STAT") return "VIRAL_STAT";
    else if (ColumnName == "ACCOUNTING_SUMMARY") return "ACCOUNTING_SUMMARY";
    else if (ColumnName == "SERVICESTATS") return "ACCOUNTING_SUMMARY";
    else if (ColumnName == "REVIEWS") return "REVIEWER";
    else if (ColumnName == "REVENUES") return "INCOME_REVENUE_JOURNAL";
    else if (ColumnName == "MEDACTIVITIES") return "MEDICATION_ACTIVITY";
    else if (ColumnName == "GENERALCODES") return "GENERAL_CODE";

    return null;
  }

  getDataMedActivity(recordIndex: number, cols: string[]): any[] {
    let record: any[] = [];
    if (recordIndex < 0 || this.MEDACTIVITIES.length == 0 || recordIndex > this.MEDACTIVITIES.length)
      return null;

    if (cols == null || cols.length == 0) return null;

    let medActy = this.MEDACTIVITIES[recordIndex];
    if (medActy == null) return null;
    for (let icol = 0; icol < cols.length; icol++) {
      switch (cols[icol]) {
        case "PROVIDER_STAT.ORGANIZATION_NAME":
        case "PROVIDER_STAT.PREFIX":
        case "PROVIDER_STAT.FIRST_NAME":
        case "PROVIDER_STAT.LAST_NAME":
        case "PROVIDER_STAT.STREET1":
        case "PROVIDER_STAT.STREET2":
        case "PROVIDER_STAT.PHONE_NUM":
        case "PROVIDER_STAT.NPI_NUM":
        case "PROVIDER_STAT.DEA_NUM":
        case "PROVIDER_STAT.CITY":
        case "PROVIDER_STAT.STATE_ID":
        case "PROVIDER_STAT.POSTAL_CODE": {
          let foundProv = this.PROVIDERSTATS.filter(p => p.trans_account == medActy.requester_trans_account);
          if (foundProv.length > 0) {
            let colName = reportDataField.parseColumnName(cols[icol]);
            record[icol] = foundProv[0][colName.toLocaleLowerCase()];
          }
          break;
        }
        case "PHARMACY_STAT.ORGANIZATION_NAME":
        case "PHARMACY_STAT.STREET1":
        case "PHARMACY_STAT.STREET2":
        case "PHARMACY_STAT.CITY":
        case "PHARMACY_STAT.STATE_ID":
        case "PHARMACY_STAT.POSTAL_CODE":
        case "PHARMACY_STAT.PHONE_NUM": {
          let foundPharm = this.PHARMACYSTATS.filter(p => p.trans_account == medActy.pharmacy_key);
          if (foundPharm.length > 0) {
            let colName = reportDataField.parseColumnName(cols[icol]);
            record[icol] = foundPharm[0][colName.toLocaleLowerCase()];
          }
          break;
        }
        case "PATIENT_STAT.FIRST_NAME":
        case "PATIENT_STAT.LAST_NAME":
        case "PATIENT_STAT.DOB":
        case "PATIENT_STAT.STREET1":
        case "PATIENT_STAT.STREET2":
        case "PATIENT_STAT.CITY":
        case "PATIENT_STAT.POSTAL_CODE":
        case "PATIENT_STAT.AGE": {
          let foundPt = this.PATIENTSTATS.filter(p => p.trans_account == medActy.trans_account);
          if (foundPt.length > 0) {
            let colName = reportDataField.parseColumnName(cols[icol]);
            let data = foundPt[0][colName.toLocaleLowerCase()];
            if (cols[icol] == "PATIENT_STAT.DOB")
              record[icol] = Iceutility.isTextDateTime(data) ? Iceutility.getDateTextEx(data, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data), null, false);
            else
              record[icol] = data;
          }
          break;
        }
        case "MEDICATION_ACTIVITY.ORDER_ENTRY_KEY":
        case "MEDICATION_ACTIVITY.SYSTEM_ENTRY_DATE":
        case "MEDICATION_ACTIVITY.ACTIVITY_DESCRIPTION":
        case "MEDICATION_ACTIVITY.SIG":
        case "MEDICATION_ACTIVITY.ADMINISTERED_AMOUNT":
        case "MEDICATION_ACTIVITY.ADMINISTERED_UNITS_TEXT":
        case "MEDICATION_ACTIVITY.RX_QUANTITY":
        case "MEDICATION_ACTIVITY.SUBSTITUTION_NOT_ALLOWED":
        case "MEDICATION_ACTIVITY.ORDER_NOTE": {
          let colName = reportDataField.parseColumnName(cols[icol]);
          let data = medActy[colName.toLocaleLowerCase()];
          if (cols[icol] == "MEDICATION_ACTIVITY.SYSTEM_ENTRY_DATE")
            record[icol] = Iceutility.isTextDateTime(data) ? Iceutility.getDateTextEx(data) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data));
          else if (cols[icol] == "MEDICATION_ACTIVITY.SUBSTITUTION_NOT_ALLOWED")
            record[icol] = Iceutility.toBoolean(data) ? "Not Allowed" : "Allowed";
          else
            record[icol] = data;
          break;
        }
      }
    }
    return record;
  }
}
